import { render, staticRenderFns } from "./ModalPrintInfosHorse.vue?vue&type=template&id=f587a124&"
import script from "./ModalPrintInfosHorse.vue?vue&type=script&lang=js&"
export * from "./ModalPrintInfosHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports